<template>
  <div class="tracey-route-page" :style="pageLayoutStyle">
    <tracey-page-chat />
  </div>
</template>

<script>
import TraceyPageChat from '../components/tracey/TraceyPageChat.vue';

export default {
  name: 'TraceyChatPage',
  components: {
    TraceyPageChat,
  },
  computed: {
    /**
     * Position the fixed page inside the space Vuetify's app layout actually
     * leaves free. $vuetify.application tracks the real footprint of every
     * `app` component (header height, drawer width incl. mini/closed state), so
     * the page stays aligned at any browser zoom level. A breakpoint guess does
     * not: the drawer is `permanent`, so it stays docked at every width, and
     * dropping the inset below mdAndUp slid the chat underneath it when zoomed in.
     */
    pageLayoutStyle() {
      const app = this.$vuetify.application;
      return {
        top: `${(app.top || 0) + (app.bar || 0)}px`,
        left: `${this.isAppLeftDrawerVisible ? app.left || 0 : 0}px`,
        bottom: `${(app.footer || 0) + (app.insetFooter || 0) + (app.bottom || 0)}px`,
      };
    },
    isAppLeftDrawerVisible() {
      const path = this.$route.path;
      if (path.includes('/unsubscribe') || path.includes('/not_found') || path.includes('/widgets/')) {
        return false;
      }
      return !!this.$auth?.isAuthenticated;
    },
  },
};
</script>

<style scoped>
/*
 * Fixed below the app bar; top/left/bottom are set inline from Vuetify's
 * app layout (see pageLayoutStyle) so it tracks the drawer at any zoom.
 */
.tracey-route-page {
  position: fixed;
  top: 64px;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  transition: left 0.2s ease;
}

.tracey-route-page ::v-deep > * {
  flex: 1;
  min-height: 0;
  height: 100%;
}

</style>
